<template>
    <div class="footer-container" :class="{ black: layout === 'black' }">
        <div
            class="btn-header"
            :class="{ black: layout === 'black', fade: layout === 'fade' }"
        >
            <div class="footer-total" v-if="total">
                <span>Total</span>
                <span class="total-price"
                    >{{ totalNumber.toLocaleString() }} บาท</span
                >
            </div>
        </div>
        <div class="btn-wrapper">
            <button v-if="checkEnable()" class="footer-btn" @click="handleClick">
                {{ text }}
            </button>
            <button v-else class="footer-btn" disabled>{{ text }}</button>
        </div>
    </div>
</template>

<script>
//helper
import Account from "@/helper/AccountHelper.js";
//core
import BzbsCart from '@/core/Cart/service/BzbsCart.js';
export default {
    name: "Footer",
    props: {
        layout: String,
        text: String,
        action: String,
        path: String,
        total: String,
        param: Object,
        validate: Boolean
    },
    data() {
        return {
            totalNumber: 0,
            token: Account.getToken()
        };
    },
    created() {
        this.setTotalNumber(this.total);
    },
    watch: {
        total(newVal) {
            this.setTotalNumber(newVal);
        },
        validate(newVal, oldVal) {
            if (newVal != oldVal) {
                this.checkEnable();
            }
        },
    },
    methods: {
        setTotalNumber(value) {
            this.totalNumber = +value;
        },
        checkEnable() {
            if (this.action === "validateSubmit") {
                return this.validate;
            } else {
                return true
            }
        },
        handleClick() {
            if (this.action === "next") {
                this.goToUrl();
            } else if (this.action === "nextWithParams") {
                this.goToWithParam();
            } else if (this.action === "validateSubmit") {
                this.submitSubscription();
            }
        },
        submitSubscription() {
            BzbsCart.apiPostSubscription(
                this.token,
                this.param
                ).subscribe(
                    data => {
                        console.log(data)
                        this.goToUrl();
                    },
                    err => {
                        console.log(err);
                    }
                );
        },
        goToUrl() {
            this.$router.push("/" + this.path);
        },
        goToWithParam() {
            this.$router.push({
                name: this.path,
                params: { data: this.param }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
$main-color: #4d341c;
.footer-container {
    position: fixed;
    color: #fff;
    bottom: 0;
    height: 105px;
    width: 100vw;
    z-index: 10;
    &.black {
        background-color: #000;
    }
    .btn-header {
        height: 4.5vh;
        &.fade {
            background-color: linear-gradient(
                to top,
                rgba(0, 0, 0, 0.7),
                rgba(0, 0, 0, 0.3) 36%,
                rgba(0, 0, 0, 0) 0%
            );
        }
        &.black {
            background-color: #000;
        }
        .footer-total {
            padding: 16px 20px 0px;
            color: #fff;
            display: flex;
            justify-content: space-between;
            .total-price {
                font-family: "PromptSemiBold";
            }
        }
    }
    .btn-wrapper {
        height: 7.5vh;
        padding: 10px 20px;
        font-size: 16px;
        width: 100%;
        .footer-btn {
            width: 100%;
            height: 100%;
            border: none;
            color: #ffffff;
            border-radius: 40px;
            background-color: $main-color;
        }
        .footer-btn:disabled {
            color: #6f6963;
            background-color: #b9b9b9;
        }
    }
}
</style>
